import Box from '@mui/material/Box';
import { type BoxProps } from '@mui/material/Box';
import { FormLabel } from 'components/ui/form/FormLabel/index.js';
import type { GenericFormField } from 'components/ui/form/GenericForm/index.js';
import { Select as BaseSelect } from 'components/ui/form/Select/index.js';
import type React from 'react';

export interface SelectProps {
  'field': GenericFormField;
  'value': string | number;
  'onChange': (event: React.ChangeEvent<HTMLInputElement>) => void;
  'onBlur'?: (event: React.FocusEvent<HTMLInputElement>) => void;
  'errorExists'?: boolean;
  'errorText'?: string;
  'disabled'?: boolean;
  'wrapperProps'?: BoxProps;
  'data-testid'?: string;
  'placeholder'?: string;
  'onClear'?: () => void;
}

export const Select = ({
  field,
  onChange,
  onClear,
  errorExists = false,
  errorText = '',
  value = '',
  disabled = false,
  wrapperProps,
  placeholder,
  ...props
}: SelectProps) => {
  return (
    <Box {...wrapperProps} flexShrink={0}>
      {field?.label && (
        <FormLabel label={field?.label} required={field?.required} />
      )}
      <BaseSelect
        {...props}
        name={`${field.name}`}
        options={field.options}
        loading={field.loading}
        value={value}
        onChange={onChange}
        onClear={onClear}
        showClear={Boolean(onClear)}
        disabled={disabled}
        required={field.required}
        placeholder={field?.placeholder ?? placeholder}
        slotProps={{ htmlInput: field.inputProps }}
        errorExists={errorExists}
        errorText={errorText}
      />
    </Box>
  );
};
